import React, { useState, useEffect } from 'react';
import useStudentAuth from '../../hooks/useStudentAuth';
import StudentDashboardContent from '../../context/student/StudentDashboardContent';
import StudentProfileContent from '../../context/student/StudentProfileContent';
import StudentSettingsContent from '../../context/student/StudentSettingsContent';
import StudentLessonsPage from './StudentLessonsPage';
import AllPaymentsPage from './AllPaymentsPage';

export default function StudentPanel() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [loading, setLoading] = useState(true);
  const { user, logout } = useStudentAuth();

  useEffect(() => {
    // Kullanıcı bilgileri zaten StudentAuthContext'ten geliyor
    if (user) {
      setLoading(false);
    }
  }, [user]);

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <StudentDashboardContent studentData={user} setCurrentPage={setCurrentPage} />;
      case 'lessons':
        return <StudentLessonsPage />;
      case 'payments':
        return <AllPaymentsPage />;
      case 'profile':
        return <StudentProfileContent studentData={user} />;
      case 'settings':
        return <StudentSettingsContent />;
      default:
        return <StudentDashboardContent studentData={user} />;
    }
  };

  // Kalan bakiye renk belirleme
  const getBalanceStyle = () => {
    const balance = user?.kalan_bakiye || 0;
    if (balance > 0) return 'text-green-600 bg-green-50'; // Alacak = yeşil
    if (balance < 0) return 'text-red-600 bg-red-50'; // Borç = kırmızı
    return 'text-blue-600 bg-blue-50';
  };

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-lg fixed h-full">
        <div className="p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">Öğrenci Paneli</h2>
          <p className="text-sm text-gray-600 mt-1">{user?.name}</p>
          
          {/* Kalan Bakiye Bilgisi */}
          {(user?.kalan_bakiye !== undefined && user?.kalan_bakiye !== null) && (
            <div className={`mt-3 px-3 py-2 rounded-lg ${getBalanceStyle()}`}>
              <p className="text-xs font-semibold">
                Kalan Bakiye:
              </p>
              <p className="text-lg font-bold">
                {user.kalan_bakiye > 0 ? '+' : ''}{user.kalan_bakiye.toFixed(2)} ₺
              </p>
            </div>
          )}
        </div>
        
        <nav className="p-4">
          <SidebarButton
            icon="🏠"
            text="Ana Sayfa"
            active={currentPage === 'dashboard'}
            onClick={() => setCurrentPage('dashboard')}
          />
          
          <SidebarButton
            icon="📚"
            text="Derslerim"
            active={currentPage === 'lessons'}
            onClick={() => setCurrentPage('lessons')}
          />
          
          <SidebarButton
            icon="💳"
            text="Ödemelerim"
            active={currentPage === 'payments'}
            onClick={() => setCurrentPage('payments')}
          />
          
          <SidebarButton
            icon="👤"
            text="Profilim"
            active={currentPage === 'profile'}
            onClick={() => setCurrentPage('profile')}
          />
          
          <SidebarButton
            icon="⚙️"
            text="Ayarlar"
            active={currentPage === 'settings'}
            onClick={() => setCurrentPage('settings')}
          />
          
          <hr className="my-4 border-gray-200" />
          
          <button
            onClick={logout}
            className="w-full text-left px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors flex items-center"
          >
            <span className="mr-3">🚪</span>
            Çıkış Yap
          </button>
        </nav>
      </div>

      {/* Main Content */}
      <div className="ml-64 flex-1">
        {renderPage()}
      </div>
    </div>
  );
}

// Sidebar Button Component
function SidebarButton({ icon, text, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-4 py-3 rounded-lg mb-2 transition-colors flex items-center ${
        active 
          ? 'bg-green-600 text-white' 
          : 'hover:bg-gray-100 text-gray-700'
      }`}
    >
      <span className="mr-3 text-lg">{icon}</span>
      {text}
    </button>
  );
}